/* Lueur Nordique — panier Shopify (AJAX), fiche produit, filtres et petites interactions. */
(function(){
  const LN = window.LN || {};
  const $ = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));
  const T = LN.t || {};
  const tr = (k, o) => (T[k] || k).replace(/\{(\w)\}/g, (_, x) => o[x]);
  const loc = (LN.locale || "fr").replace("pt-PT", "pt-PT");
  const money = c => new Intl.NumberFormat(loc, { style: "currency", currency: LN.currency || "EUR" }).format(c / 100);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const R = LN.routes || { cart: "/cart", add: "/cart/add", change: "/cart/change", root: "/" };

  /* ---------- Panier (tiroir) ---------- */
  let cart = null;
  async function loadCart(){ const r = await fetch(R.cart + ".js", { headers: { Accept: "application/json" } }); cart = await r.json(); renderCart(); return cart; }
  function renderCart(){
    if (!cart) return;
    $$(".cart-count").forEach(e => e.textContent = cart.item_count);
    const box = $("#items"); if (!box) return;
    box.innerHTML = cart.items.length ? cart.items.map((l, i) => {
      const props = l.properties ? Object.entries(l.properties).filter(([k, v]) => v && k[0] !== "_").map(([k, v]) => " · " + esc(k) + " : " + esc(v)).join("") : "";
      const vt = l.variant_title && l.variant_title !== "Default Title" ? esc(l.variant_title) : "";
      const img = l.featured_image && l.featured_image.url ? `<img src="${l.featured_image.url}${l.featured_image.url.includes("?") ? "&" : "?"}width=160" alt="">` : "";
      return `<div class="line">
        <a class="mini" href="${l.url}">${img}</a>
        <div><b>${esc(l.product_title)}</b><small>${vt}${props}</small>
          <div class="qty"><button data-line="${i + 1}" data-q="${l.quantity - 1}" aria-label="${esc(T.less || "-")}">−</button><span>${l.quantity}</span><button data-line="${i + 1}" data-q="${l.quantity + 1}" aria-label="${esc(T.more || "+")}">+</button></div>
        </div>
        <div>${money(l.final_line_price)}</div></div>`;
    }).join("") : `<p class="empty">${esc(T.empty || "")}</p>`;
    box.querySelectorAll("button[data-line]").forEach(b => b.onclick = () => changeLine(+b.dataset.line, +b.dataset.q));
    const sub = cart.total_price;
    if ($("#total")) $("#total").textContent = money(sub);
    const bar = $("#shipbar"), note = $("#shipnote");
    if (bar){
      const left = LN.freeShip - sub, pct = Math.min(100, sub / LN.freeShip * 100);
      bar.innerHTML = !cart.items.length ? tr("shipFree", {x: money(LN.freeShip)})
        : left > 0 ? tr("shipLeft", {x: money(left)}) + `<span class="bar"><i style="width:${pct}%"></i></span>`
        : `<b>${T.shipOk}</b><span class="bar"><i style="width:100%"></i></span>`;
    }
    if (note) note.textContent = !cart.items.length || sub >= LN.freeShip ? T.check : tr("shipCost", {x: money(LN.ship)}) + " " + T.check;
    const co = $("#checkout"); if (co) co.disabled = !cart.items.length;
  }
  async function changeLine(line, quantity){
    const r = await fetch(R.change + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
    cart = await r.json(); renderCart();
  }
  function openCart(){ $("#drawer").classList.add("open"); $("#overlay").classList.add("open"); $("#drawer").setAttribute("aria-hidden","false"); }
  function closeCart(){ $("#drawer").classList.remove("open"); $("#overlay").classList.remove("open"); $("#drawer").setAttribute("aria-hidden","true"); }
  let tt; function toast(t){ const e = $("#toast"); e.textContent = t; e.classList.add("show"); clearTimeout(tt); tt = setTimeout(() => e.classList.remove("show"), 1800); }

  $$(".cart-btn").forEach(b => b.onclick = e => { if (document.body.classList.contains("t-cart")) return; e.preventDefault(); openCart(); loadCart(); });
  if ($("#overlay")) $("#overlay").onclick = closeCart;
  if ($("#close-cart")) $("#close-cart").onclick = closeCart;
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });
  const co = $("#checkout"); if (co) co.closest("form").addEventListener("submit", () => { co.textContent = T.opening; });

  /* ---------- Menu ---------- */
  const burger = $(".burger");
  if (burger) burger.onclick = () => { const m = $(".menu"); m.classList.toggle("open"); burger.setAttribute("aria-expanded", m.classList.contains("open")); };
  $$(".mtrig").forEach(t => t.onclick = e => {
    e.stopPropagation();
    const li = t.parentElement, was = li.classList.contains("open");
    $$(".has-mega.open").forEach(x => { x.classList.remove("open"); x.firstElementChild.setAttribute("aria-expanded", "false"); });
    if (!was){ li.classList.add("open"); t.setAttribute("aria-expanded", "true"); }
  });
  document.addEventListener("click", e => { if (!e.target.closest(".has-mega")) $$(".has-mega.open").forEach(x => x.classList.remove("open")); });

  /* ---------- Compte à rebours Noël ---------- */
  const cd = $("#countdown");
  if (cd){
    const now = new Date(), xmas = new Date(now.getFullYear(), 11, 25), cut = new Date(LN.cutoff + "T23:59:59");
    const days = d => Math.ceil((d - now) / 86400000);
    if (now < cut) cd.innerHTML = tr("cd1", {d: days(xmas), c: T.cutoffLabel});
    else if (now < xmas) cd.innerHTML = tr("cd2", {d: days(xmas)});
  }

  /* ---------- Neige ---------- */
  const snow = $("#snow");
  if (snow && !matchMedia("(prefers-reduced-motion: reduce)").matches){
    for (let i = 0; i < 28; i++){
      const f = document.createElement("span"); f.className = "flake";
      const sz = 2 + Math.random() * 4; f.style.width = f.style.height = sz + "px";
      f.style.left = Math.random() * 100 + "%";
      f.style.animationDuration = (8 + Math.random() * 10) + "s";
      f.style.animationDelay = (-Math.random() * 15) + "s";
      snow.appendChild(f);
    }
  }

  /* ---------- Listes : filtres et tri ---------- */
  const grid = $("#grid[data-list]");
  if (grid){
    const cards = $$("#grid .card");
    let filter = new URLSearchParams(location.search).get("f") || "all";
    const apply = () => {
      let shown = 0;
      cards.forEach(c => { const ok = filter === "all" || c.dataset.tags.split(" ").includes(filter); c.style.display = ok ? "" : "none"; if (ok) shown++; });
      $$(".chip[data-f]").forEach(ch => ch.classList.toggle("on", ch.dataset.f === filter));
      const cnt = $("#count"); if (cnt) cnt.textContent = shown + " " + (shown > 1 ? T.many : T.one);
    };
    $$(".chip[data-f]").forEach(ch => ch.onclick = () => {
      filter = ch.dataset.f; apply();
      const u = new URL(location); if (filter === "all") u.searchParams.delete("f"); else u.searchParams.set("f", filter); history.replaceState(null, "", u);
    });
    const sort = $("#sort");
    if (sort) sort.onchange = () => {
      const v = sort.value;
      [...cards].sort((a, b) => v === "asc" ? a.dataset.price - b.dataset.price : v === "desc" ? b.dataset.price - a.dataset.price : a.dataset.order - b.dataset.order).forEach(c => grid.appendChild(c));
    };
    apply();
  }

  /* ---------- Fiche produit ---------- */
  const pdp = $("#pdp");
  if (pdp){
    const variants = JSON.parse(pdp.dataset.product || "[]");
    const form = $("#pform"), vid = $("#vid"), chosen = $("#chosen"), priceEls = $$(".js-price"), buyBtn = $("#buy-main");
    const select = id => {
      const v = variants.find(x => String(x.id) === String(id)); if (!v) return;
      vid.value = v.id;
      $$(".pill").forEach(x => { const on = x.dataset.id === String(v.id); x.classList.toggle("on", on); x.setAttribute("aria-pressed", on); });
      priceEls.forEach(e => e.textContent = money(v.price));
      if (chosen) chosen.textContent = v.title;
      if (buyBtn) buyBtn.disabled = !v.available;
      const u = new URL(location); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    };
    $$(".pill").forEach(b => b.onclick = () => select(b.dataset.id));
    const main = $("#main-img");
    $$(".thumb").forEach(t => t.onclick = () => { if (main){ main.removeAttribute("srcset"); main.src = t.dataset.src; } $$(".thumb").forEach(x => x.classList.remove("on")); t.classList.add("on"); });
    let q = 1; const qEl = $("#q"), qIn = $("#qty");
    const setQ = n => { q = Math.max(1, Math.min(20, n)); qEl.textContent = q; qIn.value = q; };
    $("#qminus").onclick = () => setQ(q - 1);
    $("#qplus").onclick = () => setQ(q + 1);
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const f = $("#perso");
      if (f){
        if (!f.value.trim()){ f.classList.add("err"); f.scrollIntoView({block:"center", behavior:"smooth"}); f.focus(); toast(T.needName); return; }
        f.classList.remove("err");
      }
      buyBtn.disabled = true;
      try {
        const r = await fetch(R.add + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        if (!r.ok) throw new Error();
        if (f) f.value = "";
        await loadCart(); toast(T.added); openCart();
      } catch (err) { toast(T.error); }
      buyBtn.disabled = false;
    });
    const sb = $(".js-buy-sticky"); if (sb) sb.onclick = () => form.requestSubmit ? form.requestSubmit() : buyBtn.click();

    /* Estimation de livraison : 1 à 3 jours de préparation + 7 à 15 jours de transport (jours ouvrés) */
    const addBiz = (d, n) => { const r = new Date(d); while (n > 0){ r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; };
    const fmt = d => d.toLocaleDateString(loc, { weekday: "short", day: "numeric", month: "long" });
    const now = new Date(), a = addBiz(now, 8), b = addBiz(now, 18), eta = $("#eta");
    if (eta) eta.innerHTML = tr("eta", {a: fmt(a), b: fmt(b)}) + (b < new Date(now.getFullYear(), 11, 24) && now.getMonth() >= 9 ? " <b>" + T.xmas + "</b>" : "");

    const sticky = $(".sticky-buy");
    if (sticky && buyBtn && "IntersectionObserver" in window){
      new IntersectionObserver(([e]) => sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0)).observe(buyBtn);
    }
  }

  /* ---------- Sélecteur de langue : se ferme au clic ailleurs ---------- */
  document.addEventListener("click", e => { $$("details.lang[open]").forEach(d => { if (!d.contains(e.target)) d.removeAttribute("open"); }); });

  if ($("#drawer")) loadCart().catch(() => {});
})();
